import React from 'react';
import './HomepageProviderLobby.scss';
import HomeView from '../../constants/HomeView';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import Slider from 'react-slick';
import { isMobile } from 'react-device-detect';

const CasinoProviders = HomeView.HOME_PAGE_CASINO_TILES;

type StoreProps={
  langData:any;
}

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow:  6,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 500,
  pauseOnHover: true,
};

const HomepageProvidersLobby:React.FC<StoreProps> = ({langData}) => {
  const history = useHistory();

  return (
    <div className="provider-lobby-ctn">
      <div className="provider-container">
      <div className="provider-item">{langData?.['casino_lobby']}</div>
        <div className="gradient-line"></div>
      </div>
       <Slider className='custom-slider web-view' {...settings}>
        {CasinoProviders.map((casinoProvider) => (

          <div className="provider-ctn" onClick={()=>history.push(casinoProvider.route)}>
            <img
              className="provider-img"
              src={casinoProvider.image}
              alt={casinoProvider.text + ' img'}
            />
          </div>
        ))}
   
      </Slider>
      <div className="provider-list-ctn no-scrollbar mob-view">
        {CasinoProviders.map((casinoProvider) => (

          <div className="provider-ctn" onClick={()=>history.push(casinoProvider.route)}>
            <img
              className="provider-img"
              src={casinoProvider.image}
              alt={casinoProvider.text + ' img'}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData:state.common.langData
  };
};

export default connect(
  mapStateToProps,
)(HomepageProvidersLobby)

